const isAlpha = (letter: string): boolean => /^[A-Z]$/i.test(letter);

export default isAlpha;